export default "__VITE_ASSET__CutmyvzK__"